import React from "react";
import moment from "moment";
import { getField, formatDate } from "../../util/DynamicItemUtils";

export default function PcaobEvent({ item }: any) {
  const dateParsingFormat = "YYYY-MM-DDTHH:mm:ssZ";
  const startDateDisplayFormat =
    getField(item, "startdatetime") &&
    formatDate(getField(item, "startdatetime"));
  const endDateDisplayFormat =
    getField(item, "enddatetime") &&
    formatDate(getField(item, "enddatetime"));

  const startDate = moment(
    getField(item, "startdatetime"),
    dateParsingFormat
  ).format(startDateDisplayFormat);
  const endDate = moment(
    getField(item, "enddatetime"),
    dateParsingFormat
  ).format(endDateDisplayFormat);
  let date;

  if (startDate === endDate) {
    date = startDate;
  } else {
    date = startDate + " - " + endDate;
  }

  return (
    <div>
      <p className="lead-text-lt">Event</p>
      <h3>
        <a href={getField(item, "pageurl")}>{getField(item, "title")}</a>
      </h3>
      <div className="hawk-row inline">
        {getField(item, "eventtypes") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Event Types</div>
            <div className="lead-text-st">{getField(item, "eventtypes")}</div>
          </div>
        )}
        {getField(item, "startdatetime") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Date(s)</div>
            <div className="lead-text-st">{date}</div>
          </div>
        )}
        {getField(item, "Location") ||
        getField(item, "city") ||
        getField(item, "state") ||
        getField(item, "country") ? (
          <div className="hawk-column">
            <div className="lead-text-lt">Location</div>
            <div className="lead-text-st">{getField(item, "Location")}</div>
            <div className="lead-text-st">
              {getField(item, "city")}{" "}
              {getField(item, "state") && "," + getField(item, "state")}{" "}
              {getField(item, "country") && "," + getField(item, "country")}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {getField(item, "speakers") && (
        <div className="hawk-row">
          <div className="hawk-column">
            <div className="lead-text-lt">Speakers</div>
            <div className="lead-text-st">{getField(item, "speakers")}</div>
          </div>
        </div>
      )}
      <a href={getField(item, "pageurl")} className="hawk-read-more">
        View Event
      </a>
    </div>
  );
}
